"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = /*#__PURE__*/function () {
  function Tabs(container, params) {
    _classCallCheck(this, Tabs);
    this.container = container;
    this.tabsToggles = _toConsumableArray(container.getElementsByClassName('js-tab-toggle'));
    this.tabsContent = _toConsumableArray(container.getElementsByClassName('js-tab-content'));
    this.contentContainer = _toConsumableArray(container.getElementsByClassName('js-tab-container'))[0];
    this.cursor = container.getElementsByClassName('tab-cursor')[0];
    this.delay = this.tabsContent.length ? parseInt(getComputedStyle(this.tabsContent[0]).transitionDuration.replace('s', '')) * 1000 : 1000;
    this.delay = params.transition ? 0 : this.delay;
    this.activeTab;
    this.activeContent;
    this.nextContent;
    this.init();
  }
  return _createClass(Tabs, [{
    key: "init",
    value: function init() {
      this.listen();
      if (this.activeTab) {
        this.activeTab.click();
      } else {
        this.tabsToggles[0].click();
      }
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;
      this.tabsToggles.forEach(function (item) {
        _this.activeTab = item.classList.contains('is-active') ? item : _this.activeTab;
        item.addEventListener('click', function () {
          var target = item.dataset.target;
          var activeContent = _this.container.querySelector("[data-content=".concat(target, "]"));
          if (!activeContent.classList.contains('is-active')) {
            _this.nextContent = activeContent;
            _this.setPositions();
            _this.unsetClasses();
            _this.activeTab = item;
            _this.activeContent = activeContent;
            _this.setClasses();
          }
        });
      });
      window.addEventListener('resize', function () {
        return _this.resize();
      });
    }
  }, {
    key: "resize",
    value: function resize() {
      this.contentContainer.style.height = this.activeContent.offsetHeight + 'px';
    }
  }, {
    key: "unsetClasses",
    value: function unsetClasses() {
      if (this.activeTab) {
        this.activeTab.classList.remove('is-active');
      }
      if (this.activeContent) {
        var activeContent = this.activeContent;
        this.activeContent.classList.remove('is-active');
        setTimeout(function () {
          activeContent.style.display = 'none';
        }, this.delay);
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses() {
      var _this2 = this;
      this.activeTab.classList.add('is-active');
      setTimeout(function () {
        _this2.activeContent.style.display = 'block';
      }, this.delay);
      setTimeout(function () {
        _this2.resize();
        _this2.activeContent.classList.add('is-active');
      }, this.delay + 100);
      this.setUnderline();
    }
  }, {
    key: "setPositions",
    value: function setPositions() {
      var _this3 = this;
      var position = 'prev';
      this.tabsContent.forEach(function (content) {
        if (content == _this3.nextContent) {
          position = 'next';
          return;
        } else {
          content.classList.remove('is-next', 'is-prev');
        }
        content.classList.add('is-' + position);
      });
    }
  }, {
    key: "setUnderline",
    value: function setUnderline() {
      this.cursor.style.width = this.activeTab.offsetWidth + 'px';
      this.cursor.style.left = this.activeTab.offsetLeft + 'px';
    }
  }]);
}();
document.addEventListener('DOMContentLoaded', function () {
  var tabs = _toConsumableArray(document.getElementsByClassName('js-tabs'));
  if (tabs.length) {
    tabs.forEach(function (tab) {
      return new Tabs(tab, {
        transition: tab.dataset.transition || null
      });
    });
  }
});